import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';

import {
  Input as LDSInput,
  InputProps,
} from '@letsdothis/lds/lib/candidate/Input';

import { FieldProps } from '../types';
import { getAutofillString } from '../utils';
import FieldWrapper from './FieldWrapper';

type Props = Omit<InputProps, 'error'> & FieldProps & { defaultValue?: string };

export const Input: React.FC<Props> = (props) => {
  const { control } = useFormContext();
  const {
    id,
    required = false,
    validation,
    title,
    error,
    hideLabel,
    description,
    defaultValue,
    ...rest
  } = props;

  return (
    <FieldWrapper {...{ id, required, title, error, hideLabel, description }}>
      <Controller
        control={control}
        name={id}
        rules={{
          required: required && `${title} required`,
          ...validation,
        }}
        defaultValue={defaultValue}
        as={
          <LDSInput
            {...{
              id,
              required,
              error: !!error,
              name: id,
              autoComplete: getAutofillString(id),
              ...rest,
            }}
          />
        }
      />
    </FieldWrapper>
  );
};
